/**
 * Helpers devis — type client / TVA (sans schéma DB dédié).
 * Personne morale si SIRET présent, sinon personne physique.
 */

export function hasBusinessSiret(appointmentOrIntervention) {
  const siret = `${
    appointmentOrIntervention?.siret
    || appointmentOrIntervention?.originalData?.siret
    || ''
  }`.replace(/\s/g, '');
  return /^\d{14}$/.test(siret);
}

export function resolveCustomerKind(appointmentOrIntervention) {
  return hasBusinessSiret(appointmentOrIntervention)
    ? 'business'
    : 'individual';
}

export function getCustomerKindLabel(kind) {
  return kind === 'business' ? 'Personne morale' : 'Personne physique';
}

/** TVA conseillée : 20% morale, 10% physique — sinon tva déjà stockée si plausible. */
export function resolveSuggestedVatRate(appointmentOrIntervention) {
  const raw = appointmentOrIntervention?.tva
    ?? appointmentOrIntervention?.originalData?.tva
    ?? appointmentOrIntervention?.TVA;
  const parsed = Number.parseFloat(`${raw ?? ''}`.replace(',', '.').replace(/[^\d.]/g, ''));
  if (Number.isFinite(parsed) && parsed > 0 && parsed <= 100) {
    return parsed;
  }
  return resolveCustomerKind(appointmentOrIntervention) === 'business' ? 20 : 10;
}

export function formatCivilityLabel(customerName) {
  // Formule neutre demandée : Monsieur / Madame
  return 'Monsieur / Madame';
}

export function formatFrenchDateTimeEndOfDay(dateValue) {
  const raw = `${dateValue || ''}`.trim();
  if (!raw) return { dateLabel: '', timeLabel: '23:59' };
  const datePart = raw.slice(0, 10);
  const [y, m, d] = datePart.split('-');
  if (!y || !m || !d) return { dateLabel: raw, timeLabel: '23:59' };
  return { dateLabel: `${d}/${m}/${y}`, timeLabel: '23:59' };
}

export function formatFrenchDateShort(dateValue) {
  const date = dateValue ? new Date(dateValue) : new Date();
  if (Number.isNaN(date.getTime())) return '';
  const d = String(date.getDate()).padStart(2, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const y = date.getFullYear();
  return `${d}/${m}/${y}`;
}
